import Grid from "@mui/material/Grid2";
import { FormGroup } from "@cofano/cck";
import { intl } from "LocaleWrapper";
import { Fragment, ReactNode } from "react";
import { FeetStaffelLink, GasolineStaffelLink, WaterLevelStaffelLink } from "utils/LinkUtils";
import { StaffelUnit } from "__generated__/graphql";
import { CalculationMethodDetailsByTypeProps } from "@schemas/calculationmethods/schema";

type DetailsField = {
	id: string;
	render: () => ReactNode;
}

const StaffelCalculationMethodDetails = ({ calculationMethod, hiddenFields }: CalculationMethodDetailsByTypeProps) => {
	const StaffelCalculationMethodDetailsFields: DetailsField[] = [
		{
			id: "calculationMethod.staffel",
			render: () => (
				<Grid size={4}>
					<FormGroup label={intl.formatMessage({ id: "STAFFEL" })} overflow="hidden">
						{calculationMethod.staffelUnit === StaffelUnit.Feet && (
							<FeetStaffelLink feetStaffel={calculationMethod.staffel} />
						)}
						{calculationMethod.staffelUnit === StaffelUnit.WaterLevel && (
							<WaterLevelStaffelLink waterLevelStaffel={calculationMethod.staffel} />
						)}
						{calculationMethod.staffelUnit === StaffelUnit.Gasoline && (
							<GasolineStaffelLink gasolineStaffel={calculationMethod.staffel} />
						)}
					</FormGroup>
				</Grid>
			),
		},
	];

	return (
		<>
			{StaffelCalculationMethodDetailsFields
				.filter(x => !hiddenFields?.includes(x.id))
				.map(x => (
					<Fragment key={x.id}>
						{x.render()}
					</Fragment>
				))
			}
		</>
	);
};

export default StaffelCalculationMethodDetails;
